<!--
 * @Author: 朱占伟
 * @LastEditors: 朱占伟
 * @description: 选择时长-tab切版本
 * @Date: 2021-09-09 18:21:44
 * @LastEditTime: 2021-09-26 17:07:19
-->
<template>
  <div class="SelectTabDay">
    <van-tabs v-model:active="active" color="#6153FF" @change="changeTab">
      <van-tab v-for="(item,index) in state.days" :key="'cross'+index" :name="index">
        <template #title><span :class="{'valid-err': currentDayValid.length > 0 ? currentDayValid[index]<10 : false}">Day {{ index+1 }}</span> <van-icon name="cross" @click.stop="deleteDay(index)" v-if="removable" /> </template>
        <slot :tab="item" :index="index" name="default" />
      </van-tab>

      <template #nav-right v-if="addable"> 
        <div class="add-day flex align-center justify-center" @click="addDay">
          <van-icon name="plus" class="text-lm" :class="state.days.length>=daysLimit?'disabled':''" />
        </div>
      </template>
    </van-tabs>
  </div>
</template>

<script>
import {reactive,ref,watch} from "vue"
import { useStore } from 'vuex'
import {serviceTrack} from 'model/common'
export default {
  props:{
    config:{
      type:Object,
      default:()=>{
        return {
          callBackName:'changeTab' , //监听的事件名
        }
      }
    },
    modelValue: { type: Array, required: true }, // 天数数组
    onNewTab: { type: Function, required: true },
    removable:{
      type: Boolean, default: true
    },
    addable:{
      type: Boolean, default: true
    },
    currentDayValid: {
      type: Array,
      default: ()=>[]
    }
  },

  setup(props,{emit}){
    //当前选中项
    const active = ref(0)
    const daysLimit=14
    const store=useStore()

    const dashboardStore=store.state.dashboard
    //选择的tab切换
    const changeTab = ()=>{
      emit(props.config.callBackName,{selected:active.value,dayList:state.days})
    }
    const state = reactive({
      days: props.modelValue //初始化天数
    })
    // 删除某一天
    const deleteDay = (index) => {
      const length = state.days.length;
      if (length <= 1) {
        return;
      }
      state.days.splice(index,1);
      active.value=state.days.length-1
      changeTab()
      serviceTrack('delete_day',store)
    };
   

    // 增加天数
    const addDay = () => {
      if(state.days.length>=daysLimit){
        return
      }
      state.days.push(props.onNewTab());
      // emit("update:modelValue", state.days);
      // changeTab()
      emit("update:modelValue", state.days);
      // 存在延迟问题 定时器处理一下
      setTimeout(()=>{
        active.value=state.days.length-1
        changeTab()
      })
      serviceTrack('add_day',store)
    };


    //初始化操作
    // changeTab()
    watch(props.value,(newvalue)=>{
      state.days=newvalue
    })
    return {
      changeTab,
      state,
      active,
      deleteDay,
      addDay,
      daysLimit,
      dashboardStore
    }


  }
}

</script>
<style lang="scss" scoped>
.add-day {
  width: 8%;
}

.text-lm:hover,
.text-lm:active {
  color: $main;
}

:deep(.van-tab) {
  justify-content: flex-start;
  flex: none;
}

:deep(.van-tab--active) {
  color: $main;
}

:deep(.van-tabs__wrap--scrollable .van-tab) {
  padding: 0 4px;
}

.disabled {
  color: #666;
  opacity: 0.5;
}

.valid-err {
  color: #FF5161;
}
</style>